import Box from "@mui/material/Box";
import { showOfflineAlert, showOnlineAlert } from "helpers/swalHelper";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const OfflineMessage: React.FC = () => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

useEffect(() => {
  const handleOffline = () => showOfflineAlert();
  const handleOnline = () => {
    Swal.close();
    showOnlineAlert();
  };

  window.addEventListener("offline", handleOffline);
  window.addEventListener("online", handleOnline);

  if (!navigator.onLine) {
    showOfflineAlert();
  }

  return () => {
    window.removeEventListener("offline", handleOffline);
    window.removeEventListener("online", handleOnline);
  };
}, []);

  return !isOnline ? (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 99999,
        backgroundColor: "rgba(0,0,0,0.05)",
      }}
    />
  ) : null;
};

export default OfflineMessage;
